/*!
 * Globals
 * 전역 변수 및 이벤트명
 */

// 전역 변수
export var Globals = Globals || {};

// css의 값을 포함하는 루트 변수 초기화
export class Variables {
  constructor() {
    this._addListeners();
    this._initVariables();
  }

  _addListeners() {
    document.documentElement.addEventListener(Globals.colorAttributeChange, (event) => {
      this._initVariables();
    });
  }

  _initVariables() {
    var rootStyle = getComputedStyle(document.body);
    Globals.primary = rootStyle.getPropertyValue('--bs-primary').trim();
    Globals.secondary = rootStyle.getPropertyValue('--bs-secondary').trim();

    Globals.transitionTimeShort = rootStyle
      .getPropertyValue('--bs-transition-time-short')
      .trim()
      .replace('ms', '');
    Globals.transitionTime = rootStyle
      .getPropertyValue('--bs-transition-time')
      .trim()
      .replace('ms', '');
    Globals.navSizeSlim = rootStyle.getPropertyValue('--bs-nav-size-slim').trim();

    Globals.primaryrgb = rootStyle.getPropertyValue('--bs-primary-rgb').trim();
    Globals.secondaryrgb = rootStyle.getPropertyValue('--bs-secondary-rgb').trim();

    Globals.sm = rootStyle.getPropertyValue('--bs-breakpoint-sm').trim();
    Globals.md = rootStyle.getPropertyValue('--bs-breakpoint-md').trim();
    Globals.lg = rootStyle.getPropertyValue('--bs-breakpoint-lg').trim();
    Globals.xl = rootStyle.getPropertyValue('--bs-breakpoint-xl').trim();
    Globals.xxl = rootStyle.getPropertyValue('--bs-breakpoint-xxl').trim();
    Globals.xxxl = rootStyle.getPropertyValue('--bs-breakpoint-xxxl').trim();
    Globals.direction = 'ltr';
  }
}
